/* Skalenlig vy (Lilien, Månses Design, Koppar & Muggar). Facit: docs/mockup-lilien/lilien.html (hyllan) och
   docs/mockup-hylla-styr/filter.html (förslag A: reglagen i kategoriraden, Ordna, filtret på hyllan, 2026-10-22). */
(function () {
  var root = document.querySelector('[data-lilien-hylla]');
  if (!root) return;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  var dataBas = root.getAttribute('data-hylla-url') || (window.location.pathname + '?view=hylla');
  /* Filtret (Shopifys filter.*-parametrar) gäller även hyllan: samma parametrar skickas med till ?view=hylla */
  function filterSok() {
    var q = new URLSearchParams(location.search), ut = new URLSearchParams();
    q.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'q') ut.append(k, v); });
    return ut.toString();
  }
  function dataUrl() { var f = filterSok(); return dataBas + (f ? '&' + f : ''); }
  var hamtadSok = null;
  var i18n = {};
  try {
    var i18nEl = document.querySelector('[data-lilien-i18n]');
    i18n = JSON.parse((i18nEl && i18nEl.textContent) || '{}');
  } catch (e) {
    i18n = {};
  }

  var D = null;
  var loaded = false;
  var loading = null;

  function t(key, fallback) {
    return i18n[key] || fallback;
  }

  function sida(h, vid) {
    var base = '/products/' + h;
    if (D && D.products) {
      var p = D.products.filter(function (x) { return x.handle === h; })[0];
      if (p && p.url) base = p.url;
    }
    return base + (vid ? (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + vid : '');
  }

  var kr = function (n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ' ' + t('currency_suffix', 'kr');
  };
  var cmT = function (n) { return String(Math.round(n * 2) / 2).replace('.', ','); };
  var stadaVariant = function (s) { return String(s || '').replace(/(\d)\s*cm$/i, '$1 cm'); };
  var bild = function (e, cssW) {
    /* Originalstorlek, ingen width-parameter: Shopifys förminskning av PNG med genomskinlighet blandar in produktens
       färg i kantpixlarna och ger ett ljust sudd runt produkten (Anders 2026-10-19). Webbläsaren förminskar rätt. */
    return e.url;
  };

  var ORDNING = [
    'Äggkopp', 'Espressokopp', 'Kaffekopp', 'Tekopp', 'Kaffemugg', 'Temugg', 'Mugg', 'Mjölkkanna', 'Tillbringare', 'Miniskål',
    'Dessertskål', 'Frukostskål', 'Soppskål', 'Pastaskål', 'Salladsskål', 'Djup', 'Pastatallrik'
  ];
  /* Kategori = koppar & muggar (t.o.m. Tillbringare, Månses 2026-10-23), tallrikar, annars skålar */
  var KATORD = ['koppar', 'skalar', 'tallrikar'];
  var KAT = function (g) { var n = ORDNING.indexOf(g); return n >= 0 && n < 9 ? 'koppar' : (g === 'Djup' || g === 'Pastatallrik' || g === 'Middagstallrik' || g === 'Assiett') ? 'tallrikar' : 'skalar'; };
  var KATNAMN = function (k) { return t('kat_' + k, k); };
  /* Färgen ur titeln; JS \b fungerar inte efter å, därför lookahead */
  var FARG = function (title) { var m = title.match(/(Blå|Brun|Grön|Natural|Lavendel|Prickar)(?![A-Za-zÅÄÖåäö])/); return m ? m[1] : t('farg_ovriga', 'Övriga'); };

  var PA = [];
  var BORD = [];
  var mob = innerWidth < 760;
  var PXCM = mob ? 10 : 19;
  var gap;
  var MAX;
  var forstaFlik = document.querySelector('[data-ordna]');
  var hs = { ordna: forstaFlik ? forstaFlik.dataset.ordna : 'typ' };
  var PERHYLLA = 0;

  function firstAvailableVariant(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    return v || (p.variants && p.variants[0]) || null;
  }

  function applySlutDemo() {
    var raw = '';
    try { raw = new URLSearchParams(location.search).get('slut') || ''; } catch (e) { raw = ''; }
    if (!raw || !D) return;
    raw.split(',').forEach(function (h) {
      D.products.forEach(function (p) {
        if (p.handle === h) {
          p.available = false;
          (p.variants || []).forEach(function (v) { v.available = false; });
        }
      });
    });
  }

  function buildLists() {
    PA = D.products.filter(function (p) { return p.hylla && p.hylla.hylla; }).map(function (p) {
      var g = p.title.split(' ')[0];
      return { h: p.handle, x: p, p: p.hylla.hylla, g: g, cm: p.hylla.hylla.produkt_bredd_px / 50, marke: p.vendor || '', kat: KAT(g), farg: FARG(p.title) };
    });
    /* Färg som ordning bara när hyllan har mer än en färg */
    var fargFlik = document.querySelector('[data-ordna="farg"]');
    if (fargFlik) {
      var flera = {};
      PA.forEach(function (o) { flera[o.farg] = 1; });
      fargFlik.hidden = Object.keys(flera).length < 2;
      if (fargFlik.hidden && hs.ordna === 'farg') hs.ordna = forstaFlik.dataset.ordna;
    }
    BORD = [];
    D.products.forEach(function (p) {
      (p.hylla && p.hylla.bord || []).forEach(function (e) {
        var v = e.variant ? p.variants.filter(function (x) { return x.title === e.variant; })[0] : null;
        BORD.push({ x: p, e: e, v: v, cm: Math.max(e.produkt_bredd_px, e.produkt_hojd_px) / 50 });
      });
    });
    BORD.sort(function (a, b) { return Math.round(a.cm) - Math.round(b.cm) || (a.x.title < b.x.title ? -1 : a.x.title > b.x.title ? 1 : 0); });   /* minst först, färgerna i bokstavsordning */
  }

  var plus = function (s) {
    return '<button type="button" class="plus" data-kop aria-label="' + t('add_to_cart', 'Lägg i varukorgen') + '"' +
      (s ? ' style="' + s + '"' : '') + '><span>' + t('add_to_cart', 'Lägg i varukorgen') +
      '</span><svg width="12" height="12" viewBox="0 0 12 12" stroke="currentColor" stroke-width="1.2"><path d="M6 0v12M0 6h12"/></svg></button>';
  };

  var etikett = function (namn, pris, cm, slut) {
    return namn + '<small>' + (slut ? t('sold_out', 'Tillfälligt slut') : kr(pris)) +
      ''   /* måttet bredvid priset borttaget (Anders 2026-10-19) */ + '</small>';
  };

  var namnOrd = function (a, b) { return a.x.title < b.x.title ? -1 : a.x.title > b.x.title ? 1 : 0; };
  var typNr = function (o) { var n = ORDNING.indexOf(o.g); return n < 0 ? 99 : n; };
  /* Gruppnyckeln: Varumärke, Kategori, Färg och Typ håller ihop sina produkter; Storlek har inga grupper */
  function nyckel(o) {
    return hs.ordna === 'marke' ? o.marke : hs.ordna === 'kat' ? o.kat : hs.ordna === 'farg' ? o.farg : hs.ordna === 'typ' ? o.g : '';
  }
  var STORA = ['marke', 'kat', 'farg'];   /* en ny sådan grupp börjar alltid på en ny hylla och får rubrik på väggen */
  function ordnad() {
    var l = PA.slice();
    if (hs.ordna === 'storlek') return l.sort(function (a, b) { return a.cm - b.cm || namnOrd(a, b); });
    var gk = function (o) { return hs.ordna === 'kat' ? KATORD.indexOf(o.kat) : hs.ordna === 'typ' ? typNr(o) : 0; };
    /* inom gruppen: typ, sedan storlek avrundad till hel cm (färgvarianter med några mm skillnad räknas lika), sedan namnet */
    return l.sort(function (a, b) {
      return gk(a) - gk(b) ||
        (hs.ordna === 'marke' ? a.marke.localeCompare(b.marke, 'sv') : hs.ordna === 'farg' ? a.farg.localeCompare(b.farg, 'sv') : 0) ||
        typNr(a) - typNr(b) || Math.round(a.cm) - Math.round(b.cm) || namnOrd(a, b);
    });
  }

  function rita() {
    if (!D) return;
    var bas = mob ? 10 : 19;
    var f = PXCM / bas;
    MAX = PXCM >= bas - 0.5 ? (mob ? 2 : 4) : 99;
    gap = Math.max(mob ? 8 : 14, (mob ? 14 : 48) * f);
    var minW = Math.max(mob ? 52 : 64, (mob ? 78 : 110) * f);
    var b = $('[data-hyllor]');
    var W = b.clientWidth;
    var bredd = W - (mob ? 16 : 80);
    var z = PXCM / 50;
    var REMSA = 485 * z;
    var lista = ordnad();
    var hyllor = [];
    var rad = [];
    var anv = 0;
    var sistaG = null;
    if (!lista.length) {
      b.innerHTML = '<p class="hylla-tom">' + t('empty', 'Inga produkter med de valen') + '</p>';
      $('[data-bord]').innerHTML = '';
      PERHYLLA = 0;
      uppdateraPerHylla();
      return;
    }
    /* en grupp (t.ex. Månses kaffekopp i tre färger) delas inte mellan två hyllor om den ryms på en egen */
    var grupp = {};
    lista.forEach(function (o) {
      o.etW = Math.max(o.cm * PXCM * (mob ? 1 : 1.08), minW);
      var g = nyckel(o);
      if (!g) return;
      var gr = grupp[g] || (grupp[g] = { n: 0, w: 0 });
      gr.w += (gr.n ? gap : 0) + o.etW; gr.n += 1;
    });
    lista.forEach(function (o) {
      var g = nyckel(o);
      var byt = g && g !== sistaG;
      var extra = rad.length ? (byt && !mob ? gap * 1.6 : gap) : 0;
      var ny = byt && grupp[g] && grupp[g].n <= MAX && grupp[g].w <= bredd &&
        (rad.length + grupp[g].n > MAX || anv + extra + grupp[g].w > bredd);
      var stor = STORA.indexOf(hs.ordna) >= 0 && byt && rad.length;
      if (rad.length && (ny || stor || anv + extra + o.etW > bredd || rad.length >= MAX)) {
        hyllor.push(rad);
        rad = [];
        anv = 0;
        extra = 0;
      }
      o.mellan = rad.length > 0 && byt && !mob;
      anv += extra + o.etW;
      rad.push(o);
      sistaG = g;
    });
    if (rad.length) hyllor.push(rad);
    PERHYLLA = Math.max.apply(null, hyllor.map(function (h) { return h.length; }));

    var forraG = null;
    var rubrikText = { marke: t('grupp_marke', 'Varumärke'), kat: t('grupp_kat', 'Kategori'), farg: t('grupp_farg', 'Färg') };
    b.innerHTML = hyllor.map(function (h) {
      var tot = h.reduce(function (s, o, i) {
        return s + o.etW + (i ? gap : 0) + (o.mellan ? gap * 0.6 : 0);
      }, 0);
      var x = Math.max(mob ? 8 : 40, (W - tot) / 2);
      var slots = [];
      h.forEach(function (o, i) {
        if (i) x += gap;
        if (o.mellan) x += gap * 0.6;
        slots.push(x);
        x += o.etW;
      });
      var FRONT = REMSA * 0.42;
      var VAGG = Math.max.apply(null, h.map(function (o) {
        return o.p.fot_y * z - FRONT;
      }).concat([60])) + Math.max(mob ? 40 : 52, (mob ? 44 : 170) * Math.min(1, f));
      var pl = h.map(function (o, i) {
        var p = o.p;
        var w = p.bredd * z;
        var left = slots[i] + o.etW / 2 - (p.produkt_x0 + p.produkt_bredd_px / 2) * z;
        var top = VAGG + FRONT - p.fot_y * z;
        return '<a href="' + sida(o.h) + '" class="pl' + (o.x.available ? '' : ' slut') + '" data-hh="' + o.h + '" style="left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;z-index:' + (i + 2) + '">' +
          '<img class="kopp" src="' + bild(p, w) + '" alt="' + o.x.title.replace(/"/g, '&quot;') + '" width="' + p.bredd + '" height="' + p.hojd + '" draggable="false">' +
          '</a>'; /* inget plustecken på hyllan – köpet sker i kortet */
      }).join('');
      var et = h.map(function (o, i) {
        return '<div class="et" style="left:' + slots[i] + 'px;width:' + o.etW + 'px">' +
          etikett(o.x.title, o.x.price, o.p.bredd_cm, !o.x.available) + '</div>';
      }).join('');
      var g0 = nyckel(h[0]);
      var visa = STORA.indexOf(hs.ordna) >= 0 && g0 !== forraG;
      forraG = g0;
      var rubrik = '';
      if (visa) {
        var antal = lista.filter(function (o) { return nyckel(o) === g0; }).length;
        rubrik = '<span class="hylla-grupp" style="left:' + (mob ? 12 : 40) + 'px">' + rubrikText[hs.ordna] +
          '<b>' + (hs.ordna === 'kat' ? KATNAMN(g0) : g0) + '<i>' + antal + '</i></b></span>';
      }
      return '<div class="hylla2" style="--vagg:' + VAGG + 'px;--remsa:' + REMSA + 'px;--mb:' + (8000 * z) + 'px">' +
        rubrik + '<div class="vagg2"></div><div class="remsa"></div>' + pl +
        '<div class="et-rad">' + et + '</div></div>';
    }).join('');

    $('[data-bord]').innerHTML = BORD.map(function (o) {
      var e = o.e;
      var w = e.produkt_bredd_px * z;
      var hh = e.produkt_hojd_px * z;
      var iw = e.bredd * z;
      var namn = o.x.title + (o.v ? ' ' + stadaVariant(o.v.title) : '');
      var pris = o.v ? o.v.price : o.x.price;
      var slut = o.v ? !o.v.available : !o.x.available;
      var vid = o.v ? o.v.id : (o.x.variants[0] && o.x.variants[0].id);
      /* samma kort som på hyllan öppnas vid klick; inget plustecken (Anders 2026-10-19) */
      return '<a href="' + sida(o.x.handle, o.v && o.v.id) + '" class="upp-k' + (slut ? ' slut' : '') + '" data-variant="' + vid + '" data-hh="' + o.x.handle + '" data-namn="' + namn.replace(/"/g, '&quot;') + '" data-pris="' + pris + '" data-slut="' + (slut ? '1' : '') + '" style="width:' + Math.max(w, 90) + 'px"><span class="upp-p" style="width:' + w + 'px;height:' + hh + 'px">' +
        '<img src="' + bild(e, iw) + '" alt="' + namn.replace(/"/g, '&quot;') + '" style="width:' + iw + 'px;left:' + (-e.produkt_x0 * z) + 'px;top:' + (-e.produkt_y0 * z) + 'px"></span>' +
        '<span class="et">' + etikett(namn, pris, o.cm, slut) + '</span></a>';
    }).join('');

    uppdateraPerHylla();
  }

  function uppdateraPerHylla() {
    document.querySelectorAll('[data-ordna]').forEach(function (k) {
      k.setAttribute('aria-pressed', k.dataset.ordna === hs.ordna ? 'true' : 'false');
    });
    document.querySelectorAll('[data-per-hylla]').forEach(function (u) {
      u.textContent = PERHYLLA ? PERHYLLA + ' ' + (u.getAttribute('data-text') || 'per hylla') : '';
    });
  }

  /* Cart */
  function openCartDrawer() {
    var trigger = document.querySelector('[data-cart-drawer-open]');
    if (trigger) trigger.click();
  }

  function syncCartBadges() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.hidden = false;
            el.removeAttribute('hidden');
          } else {
            el.hidden = true;
            el.setAttribute('hidden', '');
          }
        });
        if (window.TamburCartDrawer && typeof window.TamburCartDrawer.refresh === 'function') {
          return window.TamburCartDrawer.refresh();
        }
      })
      .catch(function () {});
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    }).then(function (data) {
      (data && Array.isArray(data.items) ? data.items : [data]).forEach(function (item) {
        document.dispatchEvent(new CustomEvent('tambur:tracking:add-to-cart', { detail: item }));
      });
      return syncCartBadges().then(function () {
        var delay = window.TamburAtcFeedback && window.TamburAtcFeedback.drawerDelayMs
          ? window.TamburAtcFeedback.drawerDelayMs()
          : 0;
        if (delay > 0) setTimeout(openCartDrawer, delay);
        else openCartDrawer();
      });
    });
  }

  function variantIdForProduct(handle, fromBord) {
    if (fromBord) {
      var vid = fromBord.getAttribute('data-variant');
      if (vid) return +vid;
    }
    var p = D.products.filter(function (x) { return x.handle === handle; })[0];
    if (!p) return null;
    var v = firstAvailableVariant(p);
    return v ? v.id : null;
  }

  function flashPlus(btn) {
    var span = btn.querySelector('span');
    btn.classList.add('klar');
    if (span) span.textContent = t('in_cart', 'I varukorgen ✓');
    setTimeout(function () {
      btn.classList.remove('klar');
      if (span) span.textContent = t('add_to_cart', 'Lägg i varukorgen');
    }, 2200);
  }

  /* Kortet (A): glaskort mitt på produkten. Scrollar med sidan – stängs INTE vid scroll. */
  var kort = document.createElement('div');
  kort.className = 'kortA';
  kort.hidden = true;
  document.body.appendChild(kort);
  var valt = null;

  function seeProductLabel() {
    return t('see_product', 'Se produkten →').replace(/\s*→\s*$/, '').trim() || 'Se produkten';
  }

  function ritaKort(k) {
    /* k: {h, title, pris, available, vid, cx, fot, topp, el} — samma kort för hyllan (.pl) och brickorna ovanifrån (.upp-k) */
    valt = k.h;
    $$('.pl.vald, .upp-k.vald', root).forEach(function (x) { x.classList.remove('vald'); });
    if (k.el) k.el.classList.add('vald');
    kort.innerHTML =
      '<button type="button" class="vk-x" data-kort-stang aria-label="' + t('close', 'Stäng') + '">' +
      '<svg width="12" height="12" viewBox="0 0 12 12" stroke="#1E1C19" stroke-width="1.2"><path d="M1 1l10 10M11 1L1 11"/></svg></button>' +
      '<span class="ogon">' + (D.title || 'Lilien') + '</span><b>' + k.title + '</b>' +
      '<div class="pr">' + (k.available ? kr(k.pris) : t('sold_out', 'Tillfälligt slut')) + '</div>' +
      '<div class="kk">' +
      (k.available
        ? '<button type="button" class="k-kop" data-kortkop data-hh="' + k.h + '"' + (k.vid ? ' data-vid="' + k.vid + '"' : '') + '>' + t('add_to_cart', 'Lägg i varukorgen') + '</button>'
        : '<a class="k-kop" href="' + sida(k.h, k.vid) + '">' + t('sold_out_watch', 'Tillfälligt slut · Bevaka') + '</a>') +
      '<a class="k-mer" href="' + sida(k.h, k.vid) + '">' + seeProductLabel() + ' <span>→</span></a></div>';
    kort.hidden = false;
    kort.style.animation = 'none';
    void kort.offsetWidth;
    kort.style.animation = '';
    var w = kort.offsetWidth;
    var hh = kort.offsetHeight;
    kort.style.left = Math.max(8 + scrollX, Math.min(scrollX + innerWidth - w - 8, k.cx - w / 2)) + 'px';
    kort.style.top = Math.max(k.topp - 10, (k.topp + k.fot) / 2 - hh / 2) + 'px';
  }

  function visaKort(pl) {
    var h = pl.dataset.hh;
    var o = PA.filter(function (x) { return x.h === h; })[0];
    if (!o) return;
    var p = o.p;
    var img = pl.querySelector('img.kopp');
    if (!img) return;
    var r = img.getBoundingClientRect();
    var z = r.width / p.bredd;
    ritaKort({ h: h, title: o.x.title, pris: o.x.price, available: o.x.available, vid: null, el: pl,
      cx: r.left + (p.produkt_x0 + p.produkt_bredd_px / 2) * z + scrollX, fot: r.top + p.fot_y * z + scrollY, topp: r.top + scrollY });
  }

  function visaKortBord(el) {
    var r = el.getBoundingClientRect();
    ritaKort({ h: el.dataset.hh, title: el.dataset.namn, pris: +el.dataset.pris, available: !el.dataset.slut, vid: +(el.dataset.variant || 0) || null, el: el,
      cx: r.left + r.width / 2 + scrollX, fot: r.top + r.height * 0.75 + scrollY, topp: r.top + scrollY });
  }

  function stangKort() {
    kort.hidden = true;
    valt = null;
    $$('.pl.vald, .upp-k.vald', root).forEach(function (x) { x.classList.remove('vald'); });
  }

  kort.addEventListener('click', function (e) {
    e.stopPropagation();
    if (e.target.closest('[data-kort-stang]')) return stangKort();
    var kk = e.target.closest('[data-kortkop]');
    if (kk) {
      var h = kk.getAttribute('data-hh');
      var id = +(kk.getAttribute('data-vid') || 0) || variantIdForProduct(h);
      if (!id) return;
      kk.disabled = true;
      addVariant(id)
        .then(function () {
          kk.classList.add('klar');
          kk.textContent = t('in_cart', 'I varukorgen ✓');
        })
        .catch(function (err) {
          alert((err && err.description) || t('add_error', 'Kunde inte lägga i varukorgen.'));
        })
        .finally(function () { kk.disabled = false; });
    }
  });

  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') stangKort();
  });

  root.addEventListener('click', function (e) {
    var pl = e.target.closest('.pl');
    if (pl && !e.target.closest('[data-kop]')) {
      e.preventDefault();
      if (valt === pl.dataset.hh) stangKort();
      else visaKort(pl);
      return;
    }
    var uk = e.target.closest('.upp-k');
    if (uk && !e.target.closest('[data-kop]')) {
      e.preventDefault();
      if (valt === uk.dataset.hh && !kort.hidden) stangKort();
      else visaKortBord(uk);
      return;
    }

    var kp = e.target.closest('[data-kop]');
    if (kp) {
      e.preventDefault();
      e.stopPropagation();
      var bord = kp.closest('.upp-k');
      var id = bord
        ? +(bord.getAttribute('data-variant') || 0)
        : null;
      if (!id) return;
      kp.disabled = true;
      addVariant(id)
        .then(function () { flashPlus(kp); })
        .catch(function (err) {
          alert((err && err.description) || t('add_error', 'Kunde inte lägga i varukorgen.'));
        })
        .finally(function () { kp.disabled = false; });
      return;
    }

  });

  /* Ordna-flikarna ligger i kategoriraden, utanför hyllan */
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-ordna]');
    if (!k) return;
    hs.ordna = k.dataset.ordna;
    stangKort();
    rita();
  });

  /* Stäng kort vid klick utanför produkt/kort (INTE vid scroll). Brickorna på bordet (.upp-k) räknas
     som produkter – annars stängdes kortet direkt av samma klick som öppnade det (Anders 2026-10-22). */
  document.addEventListener('click', function (e) {
    if (kort.hidden) return;
    if (!e.target.closest('.kortA') && !e.target.closest('.pl') && !e.target.closest('.upp-k')) stangKort();
  });

  var zi = document.querySelector('[data-zoom]');
  var zt;
  function zp() {
    if (!zi) return;
    zi.style.setProperty('--p', ((PXCM - zi.min) / (zi.max - zi.min) * 100) + '%');   /* linjen i kategoriraden */
  }
  if (zi) {
    if (mob) { zi.max = 16; zi.value = PXCM; }
    zi.addEventListener('input', function () {
      PXCM = +zi.value;
      zp();
      clearTimeout(zt);
      zt = setTimeout(function () { stangKort(); rita(); }, 30);
    });
    zp();
  }

  addEventListener('resize', function () {
    if (!kort.hidden) stangKort();
    var m = innerWidth < 760;
    if (m !== mob) {
      mob = m;
      PXCM = mob ? 10 : 19;
      if (zi) {
        zi.max = mob ? 16 : 30;
        zi.value = PXCM;
        zp();
      }
    }
    clearTimeout(zt);
    zt = setTimeout(rita, 100);
  });

  function ensureData() {
    if (loaded && hamtadSok === filterSok()) return Promise.resolve(D);
    if (loading) return loading;
    var sok = filterSok();
    var status = $('[data-lh-status]');
    if (status) status.hidden = false;
    /* Inte Accept: application/json — då ger Shopify Ajax Collection API
       i stället för vår Liquid-mall (?view=hylla). */
    loading = fetch(dataUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('hylla ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var json;
        try { json = JSON.parse(text); } catch (e) { throw new Error('hylla json'); }
        if (!json || !Array.isArray(json.products)) throw new Error('hylla shape');
        D = json;
        applySlutDemo();
        buildLists();
        loaded = true;
        hamtadSok = sok;
        loading = null;
        if (status) status.hidden = true;
        return D;
      })
      .catch(function (err) {
        loading = null;
        if (status) {
          status.hidden = false;
          status.textContent = t('load_error', 'Kunde inte ladda hyllan.');
        }
        throw err;
      });
    return loading;
  }

  /* Väljaren */
  function visaVy(v) {
    vy = v;
    document.querySelectorAll('[data-vyval]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.vyval === v ? 'true' : 'false');
    });
    document.documentElement.classList.toggle('lilien-vy--skala', v === 'skala');
    document.documentElement.classList.remove('lilien-vy--pending');
    document.body.classList.toggle('lilien-vy--skala', v === 'skala');
    document.body.classList.toggle('lilien-vy--vanlig', v === 'vanlig');
    root.hidden = v !== 'skala';
    if (v === 'skala') {
      ensureData().then(function () { rita(); }).catch(function () {});
    } else {
      stangKort();
    }
    try { localStorage.setItem('lilien-vy', v); } catch (e) {}
  }

  document.querySelectorAll('[data-vyval]').forEach(function (b) {
    b.addEventListener('click', function () { visaVy(b.dataset.vyval); });
  });

  /* Filtret byter adress med pushState: hämta hyllan igen med de nya valen */
  var vy = 'vanlig';
  function nyAdress() {
    if (vy !== 'skala' || hamtadSok === filterSok()) return;
    stangKort();
    ensureData().then(function () { rita(); }).catch(function () {});
  }
  ['pushState', 'replaceState'].forEach(function (f) {
    var orig = history[f];
    history[f] = function () {
      var res = orig.apply(this, arguments);
      setTimeout(nyAdress, 0);
      return res;
    };
  });
  addEventListener('popstate', function () { setTimeout(nyAdress, 0); });

  var start = 'vanlig';
  try { start = localStorage.getItem('lilien-vy') || 'vanlig'; } catch (e) {}
  if (start !== 'skala' && start !== 'vanlig') start = 'vanlig';
  visaVy(start);
})();
